import styled from 'styled-components';

export const Container = styled.div`
  width: 280px;
  border-radius: 10px;
`

export const ModalBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const ModalTitle = styled.div`
    text-align: center;
    padding: 0px 20px;
`
export const ModalDescription = styled.div`
    text-align: center;
    font-weight: 300;
    font-size: 16px;
    color: rgba(0, 0, 0, 1);
    word-break: break-word;
    overflow-wrap: break-word;
`

export const TextArea = styled.textarea`
  height: 150px;
  overflow: hidden;
  margin: 18px;
  padding: 10px 12px;
  resize: none;
  outline: none;
  border: 2px solid rgba(98, 147, 97, 0.15);
  border-radius: 6px;
  font-size: 14px;
`
